<div class="composers-container" style="width: 100%; display: flex; flex-direction: column;">
  <img src="assets/images/RevelBase_Composers.png" alt="RevelBase Composers" class="choir-resources-image">
  
  <!-- Desktop toolbar: search on the left, Add button on the right -->
  <div *ngIf="!(isHandset$ | async)" class="toolbar-row" style="display: flex; align-items: center; gap: 20px; margin-bottom: 10px;">
    <div class="search-composer" style="flex: 1;">
      <label for="composer-search">Search Composer: </label>
      <input
        id="composer-search"
        type="text"
        [(ngModel)]="searchQuery"
        (input)="searchComposers()"
        placeholder="Search by name, country, or description"
  class="narrow-search"
  style="width: 500px; max-width: 100%;"
      />
    </div>
    <button *ngIf="currentUserIsAdmin" mat-raised-button color="primary" (click)="addComposer()">Add Composer</button>
  </div>

  <!-- Handset toolbar: Only stacked search (no Add button) -->
  <div *ngIf="isHandset$ | async" class="toolbar-row" style="display: flex; flex-direction: column; gap: 8px; margin-top: 12px; margin-bottom: 1px;">
    <div class="search-composer" style="display: flex; align-items: center; gap: 8px;">
      <label for="composer-search-handset" style="white-space: nowrap;">Search Composer:</label>
      <input
        id="composer-search-handset"
        type="text"
        [(ngModel)]="searchQuery"
        (input)="searchComposers()"
        class="handset-search"
        style="width: 100%; max-width: 320px;"
      />
    </div>
  </div>

  <!-- List of Composers -->
  <div class="table-scroll">
  <table mat-table [dataSource]="filteredComposers" class="mat-elevation-z8" style="width: 100%;">
      <!-- Surname Column (desktop only via displayedColumns) -->
      <ng-container matColumnDef="surname">
        <th mat-header-cell *matHeaderCellDef>Surname</th>
        <td mat-cell *matCellDef="let composer">
          <a href="#" (click)="viewComposer(composer); $event.preventDefault()">{{ composer.surname }}</a>
        </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Composer Name</th>
        <td mat-cell *matCellDef="let composer">
          <a href="#" (click)="viewComposer(composer); $event.preventDefault()">{{ composer.fullName }}</a>
        </td>
      </ng-container>

      <!-- Songs Column -->
      <ng-container matColumnDef="songs">
        <th mat-header-cell *matHeaderCellDef>Songs</th>
        <td mat-cell *matCellDef="let composer" style="text-align: left;">
          <a href="#" class="link-button" (click)="navigateToSongs(composer.id); $event.preventDefault()">View Songs</a>
        </td>
      </ng-container>

      <!-- Country Column -->
      <ng-container matColumnDef="country">
        <th mat-header-cell *matHeaderCellDef>Country</th>
        <td mat-cell *matCellDef="let composer">{{ composer.countryOfBirth }}</td>
      </ng-container>

      <!-- Year of Birth Column -->
      <ng-container matColumnDef="yearOfBirth">
        <th mat-header-cell *matHeaderCellDef>Year of Birth</th>
        <td mat-cell *matCellDef="let composer">{{ composer.yearOfBirth }}</td>
      </ng-container>

      <!-- Year of Death Column -->
      <ng-container matColumnDef="yearOfDeath">
        <th mat-header-cell *matHeaderCellDef>Year of Death</th>
        <td mat-cell *matCellDef="let composer">{{ composer.yearOfDeath }}</td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>
          <span *ngIf="currentUserIsAdmin">Actions</span>
        </th>
        <td mat-cell *matCellDef="let composer">
          <ng-container *ngIf="currentUserIsAdmin">
            <button mat-button color="primary" (click)="editComposer(composer)">Edit</button>
            <button mat-button color="warn" (click)="deleteComposer(composer.id)">Delete</button>
          </ng-container>
        </td>
      </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
</div>